import api from '@/plugins/api'
import store from '@/store'
import hasLocalToken from '@/tools/hasLocalToken'

export default function (to, from, next) {
    if (store.get('auth/isAuthenticated')) {
        return next()
    }

    next({ name: 'loading' })

    if (hasLocalToken()) {
        api.get('auth')
            .then(response => {
                store.dispatch('auth/setDataFromAuth', response.data)
            })
            .then(() => {
                return api.get('enrollment')
            })
            .then(response => {
                const lastSelectedPeriodId = localStorage.getItem('lastSelectedPeriodId')

                store.set('enrollment/enrollments', response.data.enrollments)

                const enrollmentHasSomePeriod = response.data.enrollments.some(enrollment => enrollment.id == lastSelectedPeriodId)

                // TODO: Get last selected enrollment id from localstorage
                if (lastSelectedPeriodId && enrollmentHasSomePeriod) {
                    store.dispatch('enrollment/selectByPeriodId', lastSelectedPeriodId)
                } else if (response.data.enrollments.length > 0) {
                    store.set('enrollment/selectedIdx', 0)
                    localStorage.setItem('lastSelectedPeriodId', store.get('enrollment/selected@id'))
                }

                if (store.get('auth/role') != 'admin') {
                    // TODO: When joining to group while already have active enrollment allow to proceed
                    if (
                        !! store.get('auth/group_hash')
                        && ! store.get('auth/is_group_active')
                    ) {
                        if (to.name != 'groupPayment') {
                            return next({ name: 'groupPayment', replace: true })
                        }

                        return next(to)
                    }

                    if (response.data.enrollments.length == 0 && to.name != 'enrollment') {
                        return next({ name: 'enrollment', replace: true })
                    } else if (
                        ! store.get('enrollment/isSelectedActive')
                        && to.name != 'payment'
                        && to.name != 'paymentCallback'
                    ) {
                        return next({ name: 'payment', replace: true})
                    }
                }

                return next(to)
            })
    } else {
        return next({ name: 'home' })
    }
}
